import { ConditionTranslation, ConditionTranslationData } from "./ConditionTranslation.entity";
import { ConditionTypeEnum } from "./ConditionType.enum";
import { FlightHotelPaymentType } from "./FlightHotelPaymentType.enum";

export interface ConditionData {
  id: number;
  propertyTicker: string;
  ticker: string;
  code: string;
  name: string;
  type: string;
  conditionType: ConditionTypeEnum;
  color: string;
  ordering: number;
  chargeFirstNight: boolean;
  earlyCharge: number;
  minimumCharge: number;
  translations: ConditionTranslationData[];
  policies: string[];
  paymentTickers: string[];
  /** Only meaningful when `conditionType === ConditionTypeEnum.FLIGHT_HOTEL`. */
  flightHotelPaymentType?: FlightHotelPaymentType;
}

export class Condition {
  private constructor(
    readonly id: number,
    readonly propertyTicker: string,
    readonly ticker: string,
    readonly code: string,
    readonly name: string,
    readonly type: string,
    readonly conditionType: ConditionTypeEnum,
    readonly color: string,
    readonly ordering: number,
    readonly chargeFirstNight: boolean,
    readonly earlyCharge: number,
    readonly minimumCharge: number,
    readonly translations: ConditionTranslation[],
    readonly policies: string[],
    readonly paymentTickers: string[],
    readonly flightHotelPaymentType?: FlightHotelPaymentType
  ) {}

  getTranslation(locale: string): ConditionTranslation {
    const shortLocale = locale.split("-")[0];
    return this.translations.find(t => t.locale === shortLocale) ?? this.translations[0];
  }

  static of(data: ConditionData): Condition {
    const translations = data.translations.map(translation => ConditionTranslation.of(translation));

    return new Condition(
      data.id,
      data.propertyTicker,
      data.ticker,
      data.code,
      data.name,
      data.type,
      data.conditionType,
      data.color,
      data.ordering,
      data.chargeFirstNight,
      data.earlyCharge,
      data.minimumCharge,
      translations,
      data.policies,
      data.paymentTickers,
      data.flightHotelPaymentType
    );
  }
}
